import clsx from 'clsx';
import type { ChangeEvent } from 'react';
import { IconSearch, Input } from '../../ui/v2';

export function TableSearch({
  label,
  placeholder,
  value,
  onChange,
  className,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}) {
  return (
    <div className={clsx('w-full min-w-0 sm:w-[320px]', className)}>
      <Input
        type="search"
        size="sm"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        leading={<IconSearch size={14} />}
      />
    </div>
  );
}
